<template>
	<section>
		<p v-if="type == 1 && name != '' && total > 100 && !firstLoading">符合条件的商品约有{{total}}个。结果太多？输入更精准的关键词试试！</p>
		<h1 v-if="type == 2">待报价商品清单</h1>
		<h1 v-if="type == 3">我的历史报价信息</h1>
		<div class="f-list">
	    	<a v-show="name" href="javascript:;" @click="clearParam()">
	     		 商品关键字：
	        	<strong>{{name}}</strong>
	        	<i class=" iconfont icon-close"></i>
	     	</a>
	    </div>
	</section>
</template>

<script>
export default {
	props:["type","total","name","firstLoading"],
  	data() {
    	return {
    	};
  	},
  	methods: {
  		clearParam(){
	      this.$emit('clearParam');
	    }
  	}
};
</script>

<style lang="less" scoped>
@import "./../assets/style/config.less";
section {
  margin-top: 78px;
  padding: 0.5rem 1rem;
  background-color: #f6f6f6;
}
p{
  margin: 15px 0 5px;
  color: @gray;
  font-size: 14px;
}
h1{
  margin: 15px 0 5px;
  font-size: 16px;
}
.f-list a{
  display: inline-block;
  margin-right: .75rem;
  padding: 0 .5rem;
  height: 1.25rem;
  line-height: 1.25rem;
  background-color: #17a2b8;
  color: #fff;
  font-size: .75rem;
}
.f-list a > i{
  position: relative;
  left: .375rem;
  font-size: .75rem;
}
</style>